"use client";

import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingFERealTimeOwFOverride } from "@faire/retailer-visitor-shared/settings/useSettingFERealTimeOwFOverride";
import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { CoreCard } from "@faire/retailer-visitor-shared/views/SignUp/_components/net-terms/CoreCard";
import { IdentityVerificationPolicy } from "@faire/retailer-visitor-shared/views/SignUp/identity-verification/IdentityVerificationPolicy";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { trackSignupSignupRealTimeOwfApplicationAcceptedViewActionCategoryImpression } from "@faire/web-api--source/events/signup/actionCategoryImpression/signupRealTimeOwfApplicationAcceptedView";
import { trackSignupSignupRealTimeOwfApplicationRejectedWithoutTermsViewActionCategoryImpression } from "@faire/web-api--source/events/signup/actionCategoryImpression/signupRealTimeOwfApplicationRejectedWithoutTermsView";
import { trackSignupSignupRealTimeOwfRejectedWithTermsViewActionCategoryImpression } from "@faire/web-api--source/events/signup/actionCategoryImpression/signupRealTimeOwfRejectedWithTermsView";
import { Button } from "@faire/web/slate/Button";
import { Spacer } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { useEffect } from "react";

import { useSignUpEventTracker } from "../../_hooks/useSignUpEventTracker";

import { Headers } from "./__internal__/Headers";
import { NoTermsAndNonAutoAcceptedView } from "./__internal__/NoTermsAndNonAutoAcceptedView";

export const OwFSuccessStep: React.FC = () => {
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.OWF_SUCCESS
  );
  const { trackView } = useSignUpEventTracker(Step.OWF_SUCCESS);
  useEffect(() => {
    trackView();
  }, [trackView]);

  const handleStartShopping = () => {
    saveAndGoToNextStep(undefined);
  };

  const realTimeTermsOwfOverride = useSettingFERealTimeOwFOverride();
  const { retailer } = useRetailer();
  const isRtOwFRejected = realTimeTermsOwfOverride === "REJECT";
  const hasNoTerms = !retailer?.terms_limit?.amount_cents;

  useEffect(() => {
    if (isRtOwFRejected && hasNoTerms) {
      trackSignupSignupRealTimeOwfApplicationRejectedWithoutTermsViewActionCategoryImpression();
    } else if (isRtOwFRejected) {
      trackSignupSignupRealTimeOwfRejectedWithTermsViewActionCategoryImpression();
    } else {
      trackSignupSignupRealTimeOwfApplicationAcceptedViewActionCategoryImpression();
    }
  }, [hasNoTerms, isRtOwFRejected]);

  return isRtOwFRejected && hasNoTerms ? (
    <NoTermsAndNonAutoAcceptedView handleStartShopping={handleStartShopping} />
  ) : (
    <SignupFormContainer>
      <Headers isRtOwFRejected={isRtOwFRejected} />
      <Spacer height="4x" />
      <CoreCard />
      <Spacer height="9x" />
      <Button type="submit" data-test-id="next" onClick={handleStartShopping}>
        <StrictLocalMsg
          id="ZqYna5"
          defaultMessage="Start shopping"
          description={{
            text: "Start shopping button",
            img: "https://cdn.faire.com/fastly/e51f30ca8d0f1d1241e9f7b46834b9f3e9ccd51027b475279fc00b5ef81ba209.png",
          }}
        />
      </Button>
      <Spacer height="3x" />
      <IdentityVerificationPolicy />
    </SignupFormContainer>
  );
};
